import React, {useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TunerTable from '../../tables/tunerTables/TunerTable'
import { DetTunersContext } from '../../../context/dettuners-context';

const useStyles = makeStyles((theme) => ({
  root: {
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width:'100%',
    marginBottom:'1em'
  }
}));


export default function TunerTabPanel(props) {
  console.log("render TunerMainTabPanel");

  const classes = useStyles();
  const [detTunerState, detTunerDispatch] = useContext(DetTunersContext);

  return (
    <div className={classes.root}>
      <TunerTable data={detTunerState.tuners}></TunerTable>
    </div>
  );
}